import React from 'react';
import { ReactComponent as PlusIcon } from '../../../icons/plus.svg';
import FabSheetBackground from './FabSheetBackground.svg';
import { t } from 'i18next';

// const FabSheetBackground = () => {
//   return (
//     // biome-ignore lint/a11y/noSvgWithoutTitle: Ignore this svg
//     <svg viewBox="0 0 174 34" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
//       <rect x="0" y="0" height="100%" width="100%" fill="url(#grad)" opacity="1" />
//       <defs>
//         <radialGradient
//           id="grad"
//           gradientUnits="userSpaceOnUse"
//           cx="0"
//           cy="0"
//           r="10"
//           gradientTransform="matrix(8.7 -1.2217e-7 5.9877e-8 3.4136 87 34)"
//         >
//           <stop stop-color="rgba(195,169,255,1)" offset="0" />
//           <stop stop-color="rgba(162,137,255,1)" offset="0.5" />
//           <stop stop-color="rgba(128,104,255,1)" offset="1" />
//         </radialGradient>
//       </defs>
//     </svg>
//   );
// };

export interface FabSheetProps {
  type?: 'solid';
  state?: 'normal';
  color?: 'purple';
  size?: 'Default';
  text?: string;
  composition?: 'ic+text';
  onClick?: () => void;
  className?: string;
}

const FabSheet: React.FC<FabSheetProps> = ({
  type = 'solid',
  state = 'normal',
  color = 'purple',
  size = 'Default',
  text = 'OfflineLocation.reportButton',
  composition = 'ic+text',
  onClick,
  className = ''
}) => {
  return (
    <button
      type="button"
      className={`relative rounded-[20px] size-full cursor-pointer ${className}`}
      data-name="Type=solid, state=normal, color=purple, size=Default, composition=ic+text"
      onClick={onClick}
      style={{
        backgroundImage: `url(${FabSheetBackground})`
      }}
    >
      {/* 테두리 효과 */}
      <div className="absolute border-[#ffffff] border-[1.5px] border-solid inset-[-1.5px] pointer-events-none rounded-[21.5px] shadow-[0px_0px_4px_0px_rgba(92,61,250,0.4),0px_2px_10px_0px_rgba(92,61,250,0.3)]" />
      {/* 메인 컨텐츠 */}
      <div className="flex flex-row items-center relative size-full">
        <div className="box-border content-stretch flex flex-row gap-1.5 items-center justify-start pl-3.5 pr-4 py-2 relative size-full">
          {/* 플러스 아이콘 */}
          <div className="overflow-clip relative shrink-0 size-3.5" data-name="plus">
            <div className="absolute inset-[16.667%]" data-name="Vector">
              <div
                className="absolute bottom-[-32.143%] left-[-21.429%] right-[-21.429%] top-[-10.714%]"
                style={
                  {
                    '--fill-0': 'rgba(255, 255, 255, 1)'
                  } as React.CSSProperties
                }
              >
                <PlusIcon className="block max-w-none size-full fill-white" />
              </div>
            </div>
          </div>

          {/* 텍스트 */}
          <div
            className="[text-shadow:rgba(0,0,0,0.08)_0px_1px_2px] flex flex-col font-['Pretendard:SemiBold',_sans-serif] justify-center h-[18px] not-italic relative shrink-0 text-[#ffffff] text-center text-nowrap"
            id="node-2846_2561"
          >
            <p className="block text-[15px] font-semibold leading-none whitespace-pre">{t(text)}</p>
          </div>
        </div>
      </div>
    </button>
  );
};

export default FabSheet;
